import React, { useEffect, useState, useRef } from 'react';

const Hero = () => {
  const [bubbles, setBubbles] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    // Generate 60 bubbles
    const newBubbles = Array.from({ length: 60 }).map((_, i) => {
      const size = Math.random() * 80 + 20; 
      const left = Math.random() * 100; 
      const top = Math.random() * 100; 
      
      const tx = (Math.random() - 0.5) * 500 + 'px';
      const ty = (Math.random() - 0.5) * 500 + 'px';
      
      return {
        id: i,
        style: {
          left: `${left}%`,
          top: `${top}%`,
          width: `${size}px`,
          height: `${size}px`,
          '--tx': tx,
          '--ty': ty,
          // Burst happens shortly after load
          animationDelay: `${Math.random() * 0.5}s` 
        },
        visualStyle: {
          // Float loop is offset so they don't all move in sync
          animationDelay: `-${Math.random() * 40}s`
        }
      };
    });
    setBubbles(newBubbles);
  }, []);

  return (
    <section className="hero" ref={containerRef}>
      {bubbles.map((bubble) => (
        <div 
          key={bubble.id} 
          className="survivor-wrapper"
          style={bubble.style}
        >
          <div 
            className="bubble-visual" 
            style={bubble.visualStyle}
          ></div>
        </div>
      ))}

      <div className="hero-container">
        <h1>La spa perfetta<br />per il tuo bambino</h1>
        <p>Idroterapia e Massaggi. Sonno migliore. Sollievo dalle coliche. Pura gioia.</p>
        <a href="/" className="btn">Prenota una sessione</a>
      </div>
    </section>
  );
};

export default Hero;
